/**
 * Normalizes a group name for comparison against the built-in Geotab group
 * names (Asset Information, Driver Activity, ...). Strips whitespace,
 * punctuation and casing so that "Asset  Information", "asset-information"
 * and "Asset Information " all collapse to the same key.
 */
export function normalizeGroupName(name: string | undefined): string {
  return (name ?? "")
    .normalize("NFKC")
    .trim()
    .toLocaleLowerCase()
    .replace(/[\s_-]+/g, " ")
    .replace(/[^\p{L}\p{N} ]+/gu, "")
    .replace(/\s+/g, "")
    .trim();
}
